module.exports = __webpack_public_path__ + "static/media/dagny-logo.38bc2753.png";